import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { t } from "i18next";
import { startLogout } from "./authActions";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";

export const startRegisterSuggestCase = (suggestCase) => {

  return async (dispatch) => {
    dispatch(suggestCaseStartLoading()); 

    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_SUGGEST_CASE}`,
      "add",
      suggestCase,
      "POST"
    );

    const body = await resp.json();
    debugLogActions(':: suggestCaseActions, startRegisterSuggestCase', { 'body': body });

    if (body.ok) {
      //dispatch(registerSuggestCaseSuccess());
      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          debugLogActions(':: suggestCaseActions, startRegisterSuggestCase', { 'msg': 'Confirmed save suggest case' });
          dispatch(suggestCaseStopLoading());
        }
      });

    } else {
      dispatch(suggestCaseStopLoading());
      //dispatch(registerSuggestCaseError());
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
        dispatch(startLogout());
      }
    }
  };
};


const suggestCaseStartLoading = () => ({
  type: types.SUGGEST_CASE_START_LOADING,
});

const suggestCaseStopLoading = () => ({
  type: types.SUGGEST_CASE_STOP_LOADING,
});

export const startLoadingSuggestCasesPaginated = (page, size) => {
  return async (dispatch) => {
    try {
      // Ajustar ruta según tus const_routes
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SUGGEST_CASE}`,
        `get/${page}/${size}`
      );
      const body = await resp.json();

      debugLogActions(':: suggestActions, startLoadingSuggestCasesPaginated', { 'body': body });

      if (body.ok) {
        dispatch(loadingSuggestCasesPaginated(body.suggestCasesPaginated));
      }
    } catch (error) {
      debugErrorActions(':: suggestActions, startLoadingSuggestCasesPaginated', { 'error': error });
    }
  };
};

const loadingSuggestCasesPaginated = (suggestCasesPaginated) => ({
  type: types.SUGGEST_CASE_START_LOADING_PAGINATED,
  payload: suggestCasesPaginated,
});



export const startDownloadingSuggestWord = (id) => {
  return async (dispatch) => {
    try {
      // 1. Petición al endpoint de descarga
      // Importante: fetchToken debe estar configurado para manejar la respuesta como blob o devolver el response completo
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SUGGEST_CASE}`,
        `download/${id}`);

      if (resp.ok) {

        debugLogActions(':: suggestActions, startDownloadingSuggestWord', { 'resp': 'case ok' });

        // 2. Convertir la respuesta a un objeto Blob (formato Word)
        const blob = await resp.blob();

        // 3. Crear una URL temporal para el navegador
        const url = window.URL.createObjectURL(blob);

        // 4. Crear un link oculto y simular el click
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Sugerencia_Caso_${id}.docx`);
        document.body.appendChild(link);
        link.click();

        // 5. Limpieza de memoria
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        debugLogActions(':: suggestActions, startDownloadingSuggestWord', { 'resp': 'case else' });
        const body = await resp.json();
        //Swal.fire('Error', body.msg || 'No se pudo generar el archivo', 'error');
        if (body.code === "bak-error-001") {
          Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");
        }
        if (body.code === "bak-aut-tok-inv-001") {
          Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: suggestActions, startDownloadingSuggestWord', { 'msg':'Error downloading word', 'error': error });
      Swal.fire('Error', 'Error de conexión con el servidor', 'error');
    }
  };
};